<script>
import VCarouzel from '@/components/atomic/VCarouzel.vue';
import VLightBox from '@/components/atomic/VLightBox.vue';
import Gallery from '@/components/atomic/GalleryMasonry.vue';
import RoomList from '@/components/atomic/RoomList.vue';

export default {
  name: 'RoomRodia',
  components: {
    VCarouzel,
    VLightBox,
    Gallery,
    RoomList,
  },
  data() {
    return {
      lightbox: false,
      lightboxIdx: 0,
      amenities: false,
      heroCarouselImages: [
        {
          id: 1,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627233827/Rodia%20-%20Carousel/DSC_1930_1-min_c1uryr.jpg',
          alt: 'rizes rodia room',
        },
        {
          id: 4,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627233824/Rodia%20-%20Carousel/DSC_2699-min_heq7tv.jpg',
          alt: 'rizes house rodia room',
        },
        {
          id: 2,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627233824/Rodia%20-%20Carousel/DSC_1988-min_n9xvzq.jpg',
          alt: 'rizes-house rodia-room',
        },
        {
          id: 3,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627233824/Rodia%20-%20Carousel/DSC_2746-min_jbseb4.jpg',
          alt: 'rizes-house rodia-room',
        },
        {
          id: 5,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627233823/Rodia%20-%20Carousel/DSC_2643-min_pmatcy.jpg',
          alt: 'rizes-house rodia-room',
        },
        {
          id: 6,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627233804/Rodia%20-%20Carousel/DSC_1900-min_vrht0g.jpg',
          alt: 'rizes-house rodia-room',
        },
      ],
      galleryImages: [
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280201/Rodia%20-%20Gallery/rodia_g_15_jhxwy7.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280198/Rodia%20-%20Gallery/rodia_g_16_babkkn.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280197/Rodia%20-%20Gallery/rodia_g_17_htfbhr.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280196/Rodia%20-%20Gallery/rodia_g_13_bz4nmy.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280196/Rodia%20-%20Gallery/rodia_g_11_ix3lts.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280196/Rodia%20-%20Gallery/rodia_g_14_deriff.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280195/Rodia%20-%20Gallery/rodia_g_12_sn0yfh.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280194/Rodia%20-%20Gallery/rodia_g_8_sthllf.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280194/Rodia%20-%20Gallery/rodia_g_1_zwii84.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280193/Rodia%20-%20Gallery/rodia_g_9_uj8mcw.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280193/Rodia%20-%20Gallery/rodia_g_10_cpteht.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280192/Rodia%20-%20Gallery/rodia_g_3_zckvoy.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280191/Rodia%20-%20Gallery/rodia_g_7_jddlzm.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280190/Rodia%20-%20Gallery/rodia_g_4_hw6odm.jpg',
      ],
      lightboxGallery: [
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280201/Rodia%20-%20Gallery/rodia_g_15_jhxwy7.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280198/Rodia%20-%20Gallery/rodia_g_16_babkkn.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280197/Rodia%20-%20Gallery/rodia_g_17_htfbhr.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280196/Rodia%20-%20Gallery/rodia_g_13_bz4nmy.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280196/Rodia%20-%20Gallery/rodia_g_11_ix3lts.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280196/Rodia%20-%20Gallery/rodia_g_14_deriff.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280195/Rodia%20-%20Gallery/rodia_g_12_sn0yfh.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280194/Rodia%20-%20Gallery/rodia_g_8_sthllf.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280194/Rodia%20-%20Gallery/rodia_g_1_zwii84.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280193/Rodia%20-%20Gallery/rodia_g_9_uj8mcw.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280193/Rodia%20-%20Gallery/rodia_g_10_cpteht.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280192/Rodia%20-%20Gallery/rodia_g_3_zckvoy.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280191/Rodia%20-%20Gallery/rodia_g_7_jddlzm.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627280190/Rodia%20-%20Gallery/rodia_g_4_hw6odm.jpg',
      ],
      general: [
        this.$t('pageRodia.amenities.general.1'),
        this.$t('pageRodia.amenities.general.2'),
        this.$t('pageRodia.amenities.general.3'),
        this.$t('pageRodia.amenities.general.4'),
        this.$t('pageRodia.amenities.general.5'),
        this.$t('pageRodia.amenities.general.6'),
        this.$t('pageRodia.amenities.general.7'),
        this.$t('pageRodia.amenities.general.8'),
        this.$t('pageRodia.amenities.general.9'),
        this.$t('pageRodia.amenities.general.10'),
        this.$t('pageRodia.amenities.general.11'),
      ],
      kitchen: [
        this.$t('pageRodia.amenities.kitchen.1'),
        this.$t('pageRodia.amenities.kitchen.2'),
        this.$t('pageRodia.amenities.kitchen.3'),
        this.$t('pageRodia.amenities.kitchen.4'),
        this.$t('pageRodia.amenities.kitchen.5'),
        this.$t('pageRodia.amenities.kitchen.6'),
        this.$t('pageRodia.amenities.kitchen.7'),
        this.$t('pageRodia.amenities.kitchen.8'),
        this.$t('pageRodia.amenities.kitchen.9'),
      ],
      security: [
        this.$t('pageRodia.amenities.security.1'),
        this.$t('pageRodia.amenities.security.2'),
        this.$t('pageRodia.amenities.security.3'),
        this.$t('pageRodia.amenities.security.4'),
      ],
      other: [
        this.$t('pageRodia.amenities.other.1'),
        this.$t('pageRodia.amenities.other.2'),
        this.$t('pageRodia.amenities.other.3'),
        this.$t('pageRodia.amenities.other.4'),
        this.$t('pageRodia.amenities.other.5'),
        this.$t('pageRodia.amenities.other.6'),
        this.$t('pageRodia.amenities.other.7'),
        this.$t('pageRodia.amenities.other.8'),
        this.$t('pageRodia.amenities.other.9'),
        this.$t('pageRodia.amenities.other.10'),
      ],
    };
  },
  methods: {
    imageClicked(idx) {
      this.lightbox = true;
      this.lightboxIdx = idx;
    },
    checkScreen() {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 750) {
        this.amenities = true;
        return;
      }
      this.amenities = false;
    },
  },
  created() {
    window.addEventListener('resize', this.checkScreen);
    const windowWidth = window.innerWidth;
    if (windowWidth >= 750) {
      this.amenities = true;
      return;
    }
  },
};
</script>

<template>
  <div class="rodia">
    <header class="header">
      <v-carouzel :slides="heroCarouselImages" slideHeight="80"> </v-carouzel>
    </header>
    <section class="description">
      <div class="description__text">
        <p class="title">{{ $t('pageRodia.title') }}</p>
        <p class="content">{{ $t('pageRodia.content.p1') }}</p>
        <p class="content">{{ $t('pageRodia.content.p2') }}</p>
        <p class="content">{{ $t('pageRodia.content.p3') }}</p>
        <ul class="list">
          <li>{{ $t('pageRodia.content.l1') }}</li>
          <li>{{ $t('pageRodia.content.l2') }}</li>
          <li>{{ $t('pageRodia.content.l3') }}</li>
          <li>{{ $t('pageRodia.content.l4') }}</li>
          <li>{{ $t('pageRodia.content.l5') }}</li>
          <li>{{ $t('pageRodia.content.l6') }}</li>
        </ul>
      </div>
      <img
        class="description__img"
        src="https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280189/Rodia%20-%20Gallery/rodia_g_2_qikovn.jpg"
        alt="rodia room Rizes house"
      />
    </section>
    <section class="info">
      <img
        class="info__img"
        src="https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627280188/Rodia%20-%20Gallery/rodia_g_6_oy02rd.jpg"
        alt="rodia room Rizes house"
      />
      <div class="info__text">
        <h3 class="heading">{{ $t('pageRodia.info.heading') }}</h3>
        <ul>
          <li>
            <img src="@/assets/icons/user-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l1')
            }}/li>
          </li>

          <li>
            <img src="@/assets/icons/crop-alt-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l2')
            }}
          </li>
          <li>
            <img src="@/assets/icons/crop-alt-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l3')
            }}
          </li>
          <hr />
          <li>
            <b>{{ $t('pageRodia.info.l4') }}</b>
          </li>
          <li>
            <img src="@/assets/icons/bed-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l5')
            }}
          </li>
          <li>
            <img src="@/assets/icons/couch-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l6')
            }}
          </li>
          <hr />
          <li>
            <b>{{ $t('pageRodia.info.l7') }}</b>
          </li>
          <li>
            <img src="@/assets/icons/bed-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l8')
            }}
          </li>
          <li>
            <img src="@/assets/icons/bath-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l9')
            }}
          </li>
          <hr />
          <li>
            <b>{{ $t('pageRodia.info.l10') }}</b>
          </li>
          <li>
            <img src="@/assets/icons/bed-solid.svg" alt="Rizes House" />{{
              $t('pageRodia.info.l11')
            }}
          </li>
          <hr />
          <li>
            <b>{{ $t('pageRodia.info.l12') }}</b>
          </li>
          <hr />
          <li>
            <b>{{ $t('pageRodia.info.l13') }}</b>
          </li>
        </ul>
      </div>
    </section>
    <section class="amenities">
      <button class="btn-amenities" @click="amenities = !amenities">
        περισοτερες παροχες
        <img src="@/assets/icons/chevron-down-solid.svg" alt="" />
      </button>
      <div class="amenities__list" v-if="amenities">
        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ $t('pageRodia.amenities.general.heading') }}
          </h3>
          <room-list :benefitsArr="general" columns="1"></room-list>
        </div>

        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ $t('pageRodia.amenities.kitchen.heading') }}
          </h3>
          <room-list :benefitsArr="kitchen" columns="1"></room-list>
        </div>

        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ $t('pageRodia.amenities.security.heading') }}
          </h3>
          <room-list :benefitsArr="security" columns="1"></room-list>
        </div>

        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ $t('pageRodia.amenities.other.heading') }}
          </h3>
          <room-list :benefitsArr="other" columns="1"></room-list>
        </div>
      </div>
    </section>
    <section class="image-gallery">
      <gallery
        :images="galleryImages"
        imageAlt="rizes-house rodia halkidiki"
        @imageIndx="imageClicked"
      ></gallery>
    </section>

    <v-light-box
      :showLightbox="lightbox"
      @hideLightbox="lightbox = false"
      :images="lightboxGallery"
      :startAt="lightboxIdx"
    ></v-light-box>
  </div>
</template>

<style scoped lang="scss">
.rodia {
  background-color: hsl(var(--clr-primary-700));
}

hr {
  border: 0;
  border-top: 1px solid hsl(var(--clr-primary-100));
  margin: 4px 0;
}

.description,
.info {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 45px 0;
  background-color: hsl(var(--clr-primary-700));
}

.description {
  &__text {
    max-width: 650px;
    padding: 32px;
    background-color: hsl(var(--clr-primary-500));
    color: hsl(var(--clr-primary-100));

    .title {
      font-size: 20px;
      font-weight: 600;
      line-height: 31.6px;
    }

    .title,
    .content {
      margin-bottom: 16px;
    }

    .list {
      font-size: 14px;

      li {
        margin-bottom: 8px;
      }
    }
  }

  &__img {
    height: 400px;
    width: auto;
  }
}

.heading {
  margin-bottom: 16px;
  font-size: 22px;
  font-weight: 400;
  text-transform: uppercase;
}

.info {
  &__img {
    height: 400px;
    width: auto;
  }

  &__text {
    min-width: 450px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: hsl(var(--clr-primary-500));
    color: hsl(var(--clr-primary-100));

    li {
      display: flex;
      font-size: 16px;
      padding: 8px 0;

      img {
        width: 16px;
        height: auto;
        margin-right: 3px;
      }
    }
  }
}

.image-gallery {
  background-color: hsl(var(--clr-primary-700));
}

.btn-amenities {
  display: none;
}

.amenities {
  &__list {
    width: 100%;
    padding: 40px 0;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-around;
    justify-content: space-evenly;
    background-color: hsl(var(--clr-primary-500));

    .column {
      width: 205px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 900px) {
  .description,
  .info {
    flex-direction: column;
    padding: 15px 0;
  }

  .description {
    &__text {
      min-width: 100%;
    }

    &__img {
      display: none;
    }
  }

  .info {
    &__text {
      min-width: 100%;
    }

    &__img {
      display: none;
    }
  }
}

@media (max-width: 750px) {
  .amenities {
    &__list {
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    .column + .column {
      margin-top: 20px;
    }
  }

  .btn-amenities {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 16px 0;
    background-color: hsl(var(--clr-accent-500));
    color: hsl(var(--clr-primary-100));
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    // text-align: center;

    img {
      width: 20px;
      height: auto;
      margin-left: 8px;
    }
  }
}
</style>
